import { useRef } from "react"
import { useA11yDialog } from "react-a11y-dialog"
import useSubsequentEffect from "@hooks/useSubsequentEffect"

// Makes it easier to use `useA11yDialog in a declarative way
export default function useDialog({ isOpen, id }: { isOpen: boolean; id: string }) {
  const instanceRef = useRef<any>(null)
  const [instance, attributes] = useA11yDialog({
    id,
    title: "",
    role: "dialog",
  })
  useSubsequentEffect(() => {
    if (instance) {
      instanceRef.current = instance
    }
  }, [instance])

  useSubsequentEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        instanceRef.current?.show()
      }, 100)
    } else {
      instanceRef.current?.hide()
    }
  }, [isOpen])

  return attributes
}
